import { render, staticRenderFns } from "./ButtonComment.vue?vue&type=template&id=40497c5b&scoped=true"
import script from "./ButtonComment.vue?vue&type=script&lang=js"
export * from "./ButtonComment.vue?vue&type=script&lang=js"
import style0 from "./ButtonComment.vue?vue&type=style&index=0&id=40497c5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40497c5b",
  null
  
)

export default component.exports